let page = page_info.initialPageCount;
let lock = false;
let done = false;

if (page_info.redesigned_reviews && page_info.redesigned_reviews === "betterhelp_two") {
    $(window).resize(function() {
        if($(window).width() >= 768) {
            $('#testimonials-wrapper .testimonials').each(function() {
                const testimonials = $(this);
                resizeRows(testimonials);
            });
        } else {
            $('#testimonials-wrapper .testimonials').each(function() {
                const testimonials = $(this);

                testimonials.children('.testimonial').each(function() {
                    const testimonial = $(this);
                    testimonial.css('grid-row-end', '')
                })
            })
        }
    });

    $(window).load(function() {
        if ($(window).width() >= 768) {
            $('#testimonials-wrapper .testimonials').each(function() {
                const testimonials = $(this);
                resizeRows(testimonials);
            });
        }

        $.ajax(
            {
                url: '/api/reviews/',
                data: `page=${page}`,
                type: "GET",
                success: function (data) {
                    loadTestimonials(data, true);
                }
            }
        )
    });

    $('#load-more-button').click(function() {
        $('#reviews .reviews-container .loader-wrapper').show();
        $('#reviews .reviews-container .button-text').hide();
        $(this).prop('disabled', true);

        $.ajax(
            {
                url: '/api/reviews/',
                data: `page=${page}`,
                type: "GET",
                success: function (data) {
                    loadTestimonials(data, true)

                    const testimonials = $('#testimonials-wrapper .testimonials');
                    const firstNewDayTestimonial = $(testimonials[testimonials.length - 2]);
                    firstNewDayTestimonial.find('.testimonial').first().focus();
                }
            }
        ).always(function () {
            $('#reviews .reviews-container .loader-wrapper').hide();
            $('#reviews .reviews-container .button-text').show();
            $('#load-more-button').prop('disabled', false);
        });
    });
} else {
    $(window).scroll(function() {
        if(!done && !lock && $(window).scrollTop() + $(window).height() > $(document).height() - ($(window).width() >= 768 ? 300 : 750)) {
            lock = true;

            $.ajax(
                {
                    url: '/api/reviews/',
                    data: `page=${page}`,
                    type: "GET",
                    success: function (data) {
                        loadTestimonials(data, false);
                    }
                }
            ).always(function () {
                lock = false;
            });
        }
    });
}

// This function resizes items in CSS grid with a 'row span' as a unit
function resizeRows(testimonials) {
    // get grid row and gap sizings
    // should be 1px row height and 1px row gap
    // Therefore each 'row' unit is 2px in height
    const rowHeight = parseInt(testimonials.css('grid-auto-rows'));
    const rowGap = parseInt(testimonials.css('grid-row-gap'));
    
    // for each testimonial card in the testimonials grid section
    testimonials.children('.testimonial').each(function() {
        const testimonial = $(this)
        // 24px is the desired margin bottom, we are converting this into the 'row' unit
        const marginBottom = parseInt(testimonial.css('margin-bottom'));
        const marginBottomSpan = marginBottom / (rowHeight + rowGap);
        const testimonialHeight = Math.ceil(testimonial.find('.testimonial__content').outerHeight());
        // Calculate the ratio between the ACTUAL height + gap of the testimonial card AND the 'set' height + gap of the testimonial card, giving us the height expressed in terms of 'row' units
        const rowSpan = Math.ceil((testimonialHeight + rowGap) / (rowHeight + rowGap)) + marginBottomSpan;
        
        // apply the 'row' unit to each card
        testimonial.css('grid-row-end', 'span ' + rowSpan);
    });
}

function loadTestimonials(data, resize) {
    const result = JSON.parse(data);

    if (result.status == 'success') {
        page++;
        $('#testimonials-wrapper').append(result.reviews_html);

        if (!result.has_more) {
            $('#load-more-button').remove();
        }

        if (resize && $(window).width() >= 768) {
            $('#testimonials-wrapper .testimonials').each(function() {
                const testimonials = $(this);
                resizeRows(testimonials);
            });
        }
        observer.observe()
    }
}